module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9Ijk2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnPjxwYXRoIGQ9Ik02NC4xMjUgNTYuOTc1TDEyMC4xODguOTEyQTEyLjQ3NiAxMi40NzYgMCAwIDAgMTE1LjUgMGgtMTAzYy0xLjU4OCAwLTMuMTEzLjMtNC41MTMuODM4bDU2LjEzOCA1Ni4xMzd6Ii8+PHBhdGggZD0iTTY0LjEyNSA2OC4yODdsLTYyLjMtNjIuM0ExMi40MiAxMi40MiAwIDAgMCAwIDEyLjV2NzFDMCA5MC40IDUuNiA5NiAxMi41IDk2aDEwM2M2LjkgMCAxMi41LTUuNiAxMi41LTEyLjV2LTcxYTEyLjQ3IDEyLjQ3IDAgMCAwLTEuNzM3LTYuMzVMNjQuMTI1IDY4LjI4N3oiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/email.svg
// module id = 512
// module chunks = 75